// actions/products.actions.ts
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateProjectDto } from 'src/app/components/user/projects/dto/project.create.dto';

import { OutlineItem, ProjectItem } from 'src/app/shared/models/base.models';


export const ProjectsListActions = createActionGroup({
  source: 'Load Projects List',
  events: {
    load: emptyProps(),
    loadSuccess: props<{ projects: ProjectItem[] }>(),
    loadFailure: props<{ error: any }>(),

  },
});


export const createNewProjectActions = createActionGroup({
  source: 'Create New Project',
  events: {
    create: props<{ createPayload: CreateProjectDto }>(),
    createSuccess: props<{ project: ProjectItem }>(),
    createFailure: props<{ error: any }>(),

  },
});



// Current Product Management
export const CurrentProjectLoadActions = createActionGroup({
  source: 'Load Current Project',
  events: {
    load:props<{projectId: number}>(),
    loadSuccess: props<{ project: ProjectItem }>(),
    loadFailure: props<{ error: any }>(),

  },
});


export const ProjectUpdateActions = createActionGroup({
  source: 'Update Current Project',
  events: {
    update:props<{projectId: number, payload: Partial<CreateProjectDto>}>(),
    success: props<{ project: ProjectItem }>(),
    failure: props<{ error: any }>(),

  },
});





export const ClearCurrentProject = createAction('[Clear Current Project] Clear Current Project');